class FullWidthFont {
  constructor(element) {
    this.element = element;
    this.minFontSize = 12;
    this.maxFontSize = 1000; // Increased max
    this.padding = 0; // Adjust if needed
    this.init();
  }

  init() {
    // Store original text
    this.originalText = this.element.textContent;
    
    // Ensure proper styles
    this.element.style.whiteSpace = 'nowrap';
    this.element.style.display = 'inline-block';
    this.element.style.width = 'auto';
    
    // Initial resize
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.resize();
      });
    });
    
    // Debounced resize on window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => this.resize(), 150);
    });
  }

  getContainerWidth() {
    // Get viewport width if parent doesn't have explicit width
    const parent = this.element.parentElement;
    let width = parent.offsetWidth;
    
    if (width === 0 || !width) {
      width = window.innerWidth;
    }
    
    // Account for padding
    const styles = window.getComputedStyle(parent);
    const paddingLeft = parseFloat(styles.paddingLeft) || 0;
    const paddingRight = parseFloat(styles.paddingRight) || 0;
    
    return width - paddingLeft - paddingRight - this.padding;
  }

  resize() {
    const containerWidth = this.getContainerWidth();
    
    if (containerWidth <= 0) return;
    
    // Reset to measure
    this.element.style.fontSize = '';
    
    // Binary search for optimal font size
    let low = this.minFontSize;
    let high = this.maxFontSize;
    let optimalSize = low;
    let iterations = 0;
    const maxIterations = 50;
    
    while (low <= high && iterations < maxIterations) {
      iterations++;
      const mid = Math.floor((low + high) / 2);
      this.element.style.fontSize = `${mid}px`;
      
      // Force reflow
      void this.element.offsetWidth;
      
      const textWidth = this.element.getBoundingClientRect().width;
      
      if (textWidth <= containerWidth) {
        optimalSize = mid;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }
    
    // Set final size
    this.element.style.fontSize = `${optimalSize}px`;
  }
}

// Initialize
function initFullWidthFonts() {
  const elements = document.querySelectorAll('.full-width-font');
  elements.forEach(element => {
    if (!element._fullWidthFont) {
      element._fullWidthFont = new FullWidthFont(element);
    }
  });
}

// Run on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFullWidthFonts);
} else {
  initFullWidthFonts();
}

// Watch for new elements
if (window.MutationObserver) {
  const observer = new MutationObserver((mutations) => {
    let needsInit = false;
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.classList?.contains('full-width-font') && !node._fullWidthFont) {
            needsInit = true;
          }
          const children = node.querySelectorAll?.('.full-width-font');
          if (children?.length > 0) {
            needsInit = true;
          }
        }
      });
    });
    if (needsInit) {
      setTimeout(initFullWidthFonts, 100);
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
}